import actionTypes from './actionTypes';
import UserSource from '../../sources/user';
import { addNotification } from './notification';

const fetchAdminUsers = (authenticationToken, tenantId) => async (dispatch) => {

    try {
        const payload = await UserSource.getAllUsersForCurrentTenant({ authenticationToken, tenantId });

        dispatch({
            type: actionTypes.ADMIN_USERS_SET,
            payload,
        });

    } catch (error) {
        const response = JSON.parse(error.message);
        dispatch(addNotification({
            type: 'error',
            message: response.message,
            isPersistent: true,
        }));
    }
};

export default fetchAdminUsers;
